/**
 * #467 · Las piezas del diseño nuevo de la calculadora del motor de tarifas (maqueta aprobada por
 * Dirección el 09/10/2026). Las usan RITE, Baja Tensión (#961) y Comunidades de propietarios (#1166);
 * están separadas de lo propio de RITE (`pages/tarifas/components/RiteInstalacion.vue`) para que #470
 * las lleve al resto de herramientas sin rehacerlas. `CalcDatosHerramienta` es la que pinta los datos de entrada de una herramienta de
 * fórmula a partir de su definición: la que ocupa en Baja Tensión y en CP el sitio de lo propio de RITE.
 *
 * Se exportan juntas para que la pantalla las registre de una vez: los bancos de `scripts/` cargan
 * `tarifa-calculador-v3.vue` sin bundler y tienen que doblar cada `import` por su nombre, así que un
 * solo nombre aquí es un solo doble allí.
 */
import CalculadoraDiseno from './CalculadoraDiseno.vue';
import CalcPanel from './CalcPanel.vue';
import CalcOfertaLinea from './CalcOfertaLinea.vue';
import CalcEstadoDatos from './CalcEstadoDatos.vue';
import CalcDesplazamientoGastos from './CalcDesplazamientoGastos.vue';
import CalcResultado from './CalcResultado.vue';
import CalcGuardarDialogo from './CalcGuardarDialogo.vue';
import CalcVersiones from './CalcVersiones.vue';
import CalcDatosHerramienta from './CalcDatosHerramienta.vue';

export default {
  CalculadoraDiseno, CalcPanel, CalcOfertaLinea, CalcEstadoDatos, CalcDesplazamientoGastos,
  CalcResultado, CalcGuardarDialogo, CalcVersiones, CalcDatosHerramienta
};
